import { getModifyDataOne } from '@/api/index'

export function GetModifyData_ClaimsSettlement (data) {
  return getModifyDataOne.request({
    method: 'post',
    url: '/GetModifyData_ClaimsSettlement',
    data
  })
}

export function GetModifyData_Orders_SB (data) {
  return getModifyDataOne.request({
    method: 'post',
    url: '/GetModifyData_Orders_SB'
  })
}
export function GetModifyData_Company (data) {
  return getModifyDataOne.request({
    method: 'post',
    url: '/GetModifyData_Company',
    data
  })
}
export function GetModifyData_Users (data) {
  return getModifyDataOne.request({
    method: 'post',
    url: '/GetModifyData_Users',
    data
  })
}
export function GetModifyData_BillingTemplateList (data) {
  return getModifyDataOne.request({
    method: 'post',
    url: '/GetModifyData_BillingTemplateList',
    data
  })
}
export function GetModifyData_Warehousing_76972 (data) {
  return getModifyDataOne.request({
    method: 'post',
    url: '/GetModifyData_Warehousing_76972',
    data
  })
}
